import React from "react";
import Herosection from "../components/typesettingkpo/Herosection";
import Section2 from "../components/typesettingkpo/Section2";

const TypeSettingKPO = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      <Herosection />
      <Section2 />
    </div>
  );
};

export default TypeSettingKPO;
